import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Box, FormLabel, FormControl, Typography, Checkbox, FormHelperText } from "@mui/material";

import { useGoalngoSports } from "../../../../../../../Entity/api/queries/useSports";

import { AddEntityLocationsFormData } from "../../../../../../types/editEntityProfile-type";

const SportsTab = ({ locationIdx, branchIdx }: { locationIdx: number; branchIdx: number }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });

  const { control } = useFormContext<AddEntityLocationsFormData>();

  const { data: sports, isLoading: isSportsLoading } = useGoalngoSports();

  if (isSportsLoading || !sports) return null;

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("sportsOffered")}</Typography>
      <Controller
        name={`locations.${locationIdx}.branches.${branchIdx}.sports`}
        control={control}
        render={({ field: { value = [], onChange }, fieldState: { error } }) => (
          <FormControl error={!!error}>
            <Box sx={styles.sportsGrid}>
              {sports.map(({ id, name }) => (
                <Box key={id} sx={styles.sportItem}>
                  <Checkbox
                    size="small"
                    checked={value.includes(id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onChange([...value, id]);
                      } else {
                        onChange(value.filter((s: number) => s !== id));
                      }
                    }}
                  />
                  <FormLabel sx={styles.sportLabel}>{name}</FormLabel>
                </Box>
              ))}
            </Box>
            {error && <FormHelperText>{t(error.message)}</FormHelperText>}
          </FormControl>
        )}
      />
    </Box>
  );
};

export default SportsTab;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  title: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  sportsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "16px",
  },
  sportItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sportLabel: {
    color: "var(--Gray-700, #344054)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
};
